import React, { useEffect } from 'react'
import { defPath } from '../config/defPath'
import NewHeader from "../components/layout/NewHeader"
import Modal from "../components/layout/modal"
import OptionsTada from '../components/layout/OptionsTada'
import { Controls } from "../components/layout/menu_help"
import Popups from '../components/layout/popup'

const tada = () => {

    function handleClick(event: any) {
        window.dataLayer.push({
          'event': 'GAEvent',
          'event_category': 'Content',
          'event_action': 'Button',
          'event_label':  'Get Aguila - You won points and coins' ,
          'interaction':'true',
          'component_name': 'Modo_Carrera_Codes',
          'element_text': 'Comprar Aguila en TaDa',
        });

    }

    return (
        <>
            <NewHeader />
            <Modal />
            <Popups />
            <Controls isStadium= {false} />
            <div className='tadaSection'>
                <div className="tadaSection__container scrollBar">
                    <section className="tadaSection__body">
                        <OptionsTada />
                        <div className="tadaSection__bottom">
                            <a href='https://onelink.tadadelivery.com.co/6iLg/cwgnbeud' onClick={handleClick} target='_blank' className="btnFull">
                                <p className='btnFull__body'>
                                    Comprar
                                    <img src={`${defPath}/assets/images/icons/logo_aguila.svg`} alt="logo aguila" />
                                    En
                                    <img src={`${defPath}/assets/images/icons/logo_tada_blue.svg`} alt="logo tada" />
                                </p>
                            </a>
                            <p className='textBtn'>
                                Recuerda que todas nuestras compras te dan puntos
                            </p>
                        </div>
                    </section>
                </div>
            </div>
        </>
    )
}

export default tada

